import { Browser } from "../../core/browser";
import { Dialog } from "../../dialog/dialog";
import { AuxiliumComponent } from "../auxilium-component";

export class Card extends AuxiliumComponent {
	static observedAttributes = ["scroll", "flush", "hoverable", "hide-blur"];

	constructor() {
		super();

		this.heading = {
			text: this.getAttribute("heading"),
			size: this.getAttribute("heading-size"),
			subtitle: this.getAttribute("subtitle")
		};

		this.scroll = this.hasAttribute("scroll");
		this.image = this.getAttribute("image");
		this.video = this.getAttribute("video");
		this.link = this.getAttribute("link");
		this.audio = this.getAttribute("audio");
		this.tableCard = this.hasAttribute("table-card"); ''
		this.allowPreview = this.hasAttribute("allow-preview");
		this.hideBlur = this.hasAttribute("hide-blur");
		this.flush = this.hasAttribute("flush");
		this.flushHeader = this.hasAttribute("flush-header");
		this.variation = this.getAttribute("variation");
		this.hoverable = this.hasAttribute("hoverable");
		this.size = this.getAttribute("size")?.toLowerCase();

		if (!this.heading.size) {
			this.heading.size = (() => {
				switch (this.size) {
					case "xs": return "5";
					case "sm": return "4";
					case "md": return "2";
					case "lg": return "1";
					case "body": return "body";
					default: return "3";
				}
			})();
		}
	}

	setBody(content) {
		const bodyElement = this.querySelector(".card-body") ?? this.appendChild(document.createElementWithContents("div", null, { className: "card-body" }));

		bodyElement.innerHTML = content;
	}

	parsedCallback() {
		this.classList.add("card-frame");

		if (this.flush) { this.classList.add("card--flush"); }
		if (this.variation) { this.classList.add(`card-${this.variation}`); }
		if (this.size) { this.classList.add(`card--${this.size}`); }

		if (this.image || this.video || this.audio) {
			this.querySelector(":scope>.card-header,:scope> chip-cardheader")?.remove();
		}

		if (this.image) {
			const loader = document.createElementWithContents("chip-loading", null, { type: "image", size: "xxxxl" });

			function imgLoaded(ev) {
				loader.remove();
				ev.target.classList.add("image--loaded");
			}

			const img = document.createElementWithContents("img", null, {
				loading: "lazy",
				src: this.image,
				onload: ev => imgLoaded(ev),
				alt: "Card Image Preview"
			}), visibleImg = !this.hideBlur ? img.cloneNode() : null;

			if (visibleImg) { visibleImg.onload = ev => imgLoaded(ev); }

			this.prepend(document.createElementWithContents("chip-cardheader", [loader, img, visibleImg], {
				onclick: () => this.allowPreview ? Dialog.ShowImage(this.image) : null
			}));
		}

		if (this.video) {
			const vid = document.createElementWithContents("video", `<source src="${this.video}"></source>`, {
				controls: true
			});

			this.prepend(document.createElementWithContents("chip-cardheader", vid));
		}

		if (this.audio) {
			const ado = document.createElementWithContents("audio", null, {
				controls: true,
				src: this.audio
			});

			this.prepend(document.createElementWithContents("chip-cardheader", ado));
		}

		const card = document.createElementWithContents(this.link ? "a" : "div",
			this.heading.text ?
				`
				<div class="card-header">
					<chip-header>${this.heading.text}</chip-header>
					<div class="card-subtitle">${this.heading.subtitle}</div>
				</div>
			`.trim() : document.createElementWithContents("div", this.querySelector(":scope>chip-cardheader"), { className: "card-header" })
		), header = card.querySelector("chip-cardheader");

		if (this.link) { card.href = Browser.ResolveRelativeURL(this.link); }

		if (!header) {
			if (!this.heading.text) { card.querySelector(".card-title")?.remove(); }
			else { card.querySelector(".card-header>chip-header:first-child").size = this.heading.size; }

			if (!this.heading.subtitle) { card.querySelector(".card-subtitle")?.remove(); }

			if (!this.heading.text && !this.heading.subtitle) { card.querySelector(".card-header").remove(); }
		} else {
			header.addEventListener("click", () => this.raiseEvent("headerclick"));
		}

		if (this.innerHTML.trim() !== "") {
			card.appendChild(document.createElementWithContents("div", this.childNodes, { className: "card-body" }));
		}

		this.append(card);
	}
}